export default "__VITE_ASSET__DPkyyUk4__"